import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicModal } from 'core/components';
import { RelationshipChangeModal } from 'application/facility-order-new-flow-insurance/components';
import { FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate } from "themes/application/facility-order-new-flow-insurance/components";

function FacilityOrderPatientNewFlowInsuranceEditModalTemplate({ facilityOrderPatientNewFlowInsuranceEditModalStore }) {
    const {
        facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore,
        relationshipChangeModal,
        disableForm
    } = facilityOrderPatientNewFlowInsuranceEditModalStore;

    return (
        <div style={{ minHeight: 300 }}>
            <div className="modal__body">
                <div className="u-flex u-flex--default">
                    <label className='modal__header__title u-mar--bottom--med'>Insurances</label>
                </div>
                <div>
                    <FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate
                        facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                        disableForm={disableForm}
                    />
                </div>
            </div>
            <BaasicModal modalParams={relationshipChangeModal} className="modal__content modal--med">
                <RelationshipChangeModal />
            </BaasicModal>
        </div>
    )
}

FacilityOrderPatientNewFlowInsuranceEditModalTemplate.propTypes = {
    facilityOrderPatientNewFlowInsuranceEditModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderPatientNewFlowInsuranceEditModalTemplate);
